import { findByNavigator, loadFromLocal } from '../helpers/lookups';

const ENGLISH = 'en-US';
const CHINESE = 'zh-Hant';
const NA_DOMAIN = 'members.junglescout.com';
const CHINESE_DOMAIN = 'members.junglescout.cn';

export class LanguageDetector {
  constructor() {}

  detect() {
    try {
      // Global Data Check
      const globalVal = loadFromLocal();

      if (globalVal) return globalVal;

      // Browser Language Check
      const browserVal = findByNavigator();

      if (browserVal) {
        const usableBrowserVal = this._normalizeBrowserLang(browserVal);

        if (usableBrowserVal) return usableBrowserVal;
      }
    } catch (_ex) {}

    // If all checks failed or err default lang based on domain
    return this._defaultByDomain();
  }

  _defaultByDomain() {
    const domain = window.location.host;

    switch (domain) {
      case NA_DOMAIN:
        return ENGLISH;
      case CHINESE_DOMAIN:
        return CHINESE;

      default:
        return ENGLISH;
    }
  }

  _normalizeBrowserLang(browserVal: string) {
    if (!browserVal) return null;

    // match examples: en || en-US || EN-GB || en-hant
    if (browserVal.match(/^en(?:-[a-z]{2,4})?$/i)) return ENGLISH;

    if (browserVal.match(/^zh(?:-[a-z]{2,4})?$/i)) return CHINESE;

    return null;
  }
}
